var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightAngleBracket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.60005 6.00005L0.700049 2.10005C0.516715 1.91672 0.425049 1.68338 0.425049 1.40005C0.425049 1.11672 0.516715 0.883382 0.700049 0.700049C0.883382 0.516715 1.11672 0.425049 1.40005 0.425049C1.68338 0.425049 1.91672 0.516715 2.10005 0.700049L6.70005 5.30005C6.80005 5.40005 6.87088 5.50838 6.91255 5.62505C6.95422 5.74172 6.97505 5.86672 6.97505 6.00005C6.97505 6.13338 6.95422 6.25838 6.91255 6.37505C6.87088 6.49172 6.80005 6.60005 6.70005 6.70005L2.10005 11.3C1.91672 11.4834 1.68338 11.575 1.40005 11.575C1.11672 11.575 0.883382 11.4834 0.700049 11.3C0.516715 11.1167 0.425049 10.8834 0.425049 10.6C0.425049 10.3167 0.516715 10.0834 0.700049 9.90005L4.60005 6.00005Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightAngleBracket);
export default __webpack_public_path__ + "static/media/right-angle-bracket.37c255a22fc05bf1e1c19342357704db.svg";
export { ForwardRef as ReactComponent };